import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import i18n from '@/plugins/vue-i18n';;
export class ExportQRPayment {
  constructor() {
    // excel file type
  }
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }

  static async exportQRPaymentReport(qrPaymentReports, startDate, endDate){
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    worksheet.columns = [
      {
        header: i18n.t('market.market'),
        key: 1,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.payment_date'),
        key: 2,
        width: 25,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('qr_payment.reference_number'),
        key: 3,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: "Ref1",
        key: 4,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: "Ref2",
        key: 5,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.customer_market_id'),
        key: 6,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('customer.title'),
        key: 7,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.space'),
        key: 8,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.amount'),
        key: 9,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.document_id'),
        key: 10,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('status'),
        key: 11,
        width: 25,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.receipt_id'),
        key: 12,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.confirmed_payment_date'),
        key: 13,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.refund_payment'),
        key: 14,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.confirmed_refund_date'),
        key: 15,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.refund_payment_by'),
        key: 16,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('note'),
        key: 17,
        width: 40,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      }
    ]

    for(let qrPaymentReport of qrPaymentReports){
      let note = "";
      if (qrPaymentReport.voidedNote) {
        note += `${i18n.t('account.user')}: ` + qrPaymentReport.voidedNote;
      }
      if (qrPaymentReport.voidedResult) {
        if (qrPaymentReport.voidedResult.errorDesc_th) {
          note += "\n" + `${i18n.t('account.system')}: ` + qrPaymentReport.voidedResult.errorDesc_th;
        } else if (qrPaymentReport.voidedResult.errorDesc) {
          note += "\n" + `${i18n.t('account.system')}: ` + qrPaymentReport.voidedResult.errorDesc;
        }
      }
      worksheet.addRow({
        1: qrPaymentReport.marketName,
        2: qrPaymentReport.paymentTimeStamp ? new Date(moment(qrPaymentReport.paymentTimeStamp).format("YYYY-MM-DD HH:mm:ss")) : "",
        3: qrPaymentReport.objectId,
        4: qrPaymentReport.ref1,
        5: qrPaymentReport.ref2,
        6: qrPaymentReport.customerMarketId,
        7: qrPaymentReport.customerData,
        8: qrPaymentReport.areasName,
        9: qrPaymentReport.amount,
        10: qrPaymentReport.documentId,
        11: qrPaymentReport.status,
        12: qrPaymentReport.receiptDocumentId,
        13: qrPaymentReport.reconciledTimeStamp ? new Date(moment(qrPaymentReport.reconciledTimeStamp).format("YYYY-MM-DD HH:mm:ss")) : "",
        14: qrPaymentReport.voidStatus != i18n.t('payment.refund') ? qrPaymentReport.voidStatus : "",
        15: qrPaymentReport.voidedDate ? new Date(moment(qrPaymentReport.voidedDate).format("YYYY-MM-DD HH:mm:ss")) : "",
        16: qrPaymentReport.voidedByFullName,
        17: note,
      })
    }

    return this.saveFile(workbook, `qrPayment-${moment(startDate).format("D-M-YYYY")}-to-${moment(endDate).format("D-M-YYYY")}`);
  }
}